// Gestion de la recherche sur mobile et des problèmes d'accessibilité des modales
function initRechercheMobile() {

  // Ferme une modale en utilisant les mécanismes existants du système
  function closeModal(modalElement, modalId) {
    // Vérifier si la modale est présente dans le DOM
    if (!modalElement || !modalElement.classList) {
      console.warn("Élément de modale non valide pour fermeture");
      return;
    }

    try {
      updateButtonCriteriaCount(modalElement);
      modalElement.classList.remove("open");
      modalElement.setAttribute("aria-hidden", "true");
      const openButton = document.querySelector(`.js-hq-modale-btn[data-modale-id="${modalId}"]`);
      if (openButton) {
        openButton.classList.remove("active");
      }
      document.body.style.overflow = "auto";

      const otherElements = getSiblingsElements(modalElement);
      if (otherElements && otherElements.length) {
        otherElements.forEach(element => {
          if (element) {
            element.setAttribute("aria-hidden", "false");
            element.removeAttribute("inert");
          }
        });
      }

      if (openButton) {
        openButton.focus();
      }
    } catch (error) {
      console.error("Erreur lors de la fermeture de la modale:", error);
      const closeButton = modalElement.querySelector(".js-hq-close-btn");
      if (closeButton) {
        closeButton.click();
        return;
      }

      modalElement.classList.remove("active", "visible", "show", "opened", "open");
      modalElement.classList.add("inactive", "hidden");
      modalElement.setAttribute("aria-hidden", "true");
      document.body.classList.remove("no-scroll", "modal-open");
      document.body.style.overflow = "auto";
    }
  }

  // Récupère tous les éléments frères d'un élément donné pour la gestion d'accessibilité
  function getSiblingsElements(element) {
    let siblings = [];
    if (!element.parentNode) return siblings;

    let sibling = element.parentNode.firstChild;
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== element) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }

    const header = document.querySelector("header");
    const footer = document.querySelector("footer");
    const navDocsContainer = document.querySelector(".nav-docs-container");
    const containerMenuBtn = document.querySelector(".container-menu-btn");

    return [...siblings, header, footer, navDocsContainer, containerMenuBtn].filter(elem => elem != null);
  }

  // Configure les boutons de filtrage et leurs événements dans la modale mobile
  function setupMobileFilterButtons() {
    const modal = document.querySelector(".js-hq-modale[data-modale-id=\"modale-1002\"]");

    if(modal){
      const applyFilterButton = modal.querySelector(".js-button-filtres");
      const resetFilterButton = modal.querySelector(".js-button-reset");

      if (applyFilterButton) {
        applyFilterButton.addEventListener("click", function () {
          if (window.goForm) {
            closeModal(modal, modal.getAttribute("data-modale-id"));
          }
        });
      }

      if (resetFilterButton) {
        resetFilterButton.addEventListener("click", function () {
          updateCriteriaCount(modal, 0);
        });
      }

      setupFilterChangeObserver(modal);
    }
  }

  function updateCriteriaCount(modalElement, count = null) {
    const criteriaElement = modalElement.querySelector(".js-criterias-1");
    if (!criteriaElement) return;

    if (count === null) {
      count = countActiveFilters(modalElement);
    }

    criteriaElement.textContent = count === 1
      ? `(1 critère actif)`
      : `(${count} critères actifs)`;
  }

  // Met à jour le compteur de critères affiché sur le bouton d'ouverture de la modale
  function updateButtonCriteriaCount(modalElement) {
    const count = countActiveFilters(modalElement);
    const modalId = modalElement.getAttribute("data-modale-id");

    const button = document.querySelector(`.js-hq-modale-btn[data-modale-id="${modalId}"]`);
    if (!button) return;

    let criteriaElement = button.querySelector(".js-criterias-2");

    if (!criteriaElement) {
      const buttonParent = button.parentElement;
      if (buttonParent) {
        criteriaElement = buttonParent.querySelector(".js-criterias-2");
      }
    }

    if (criteriaElement) {
      if (count === 0) {
        criteriaElement.textContent = "";
      } else {
        criteriaElement.textContent = count === 1
          ? `(1 critère actif)`
          : `(${count} critères actifs)`;
      }
    }
  }

  // Compte le nombre total de filtres actifs dans la modale
  function countActiveFilters(modalElement) {
    let count = 0;

    modalElement.querySelectorAll('input[type="text"]:not(.js-input-marque)').forEach(input => {
      if (input.value.trim() !== '') count++;
    });

    modalElement.querySelectorAll('input[type="number"]').forEach(input => {
      if (input.value !== '') count++;
    });

    modalElement.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      if (checkbox.checked) count++;
    });

    count += modalElement.querySelectorAll(".selected-item").length;

    return count;
  }

  // Configure les observateurs d'événements pour détecter les changements de filtres
  function setupFilterChangeObserver(modalElement) {

      const allInputs = modalElement.querySelectorAll('input[type="text"], input[type="number"]');
      allInputs.forEach(input => {
        input.addEventListener("input", () => {
          updateCriteriaCount(modalElement);
        });
      });

      const checkboxes = modalElement.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change", () => {
          updateCriteriaCount(modalElement);
        });
      });

      const selectedItemsContainer = modalElement.querySelector(".js-selected-items");
      if (selectedItemsContainer) {
        const observer = new MutationObserver(() => {
          updateCriteriaCount(modalElement);
        });

      observer.observe(selectedItemsContainer, {
        childList: true,
        subtree: true
      });
    }

      const closeButtons = modalElement.querySelectorAll(".js-hq-close-btn, .hq-modal-close-btn");
      closeButtons.forEach(closeBtn => {
        closeBtn.addEventListener("click", () => {
          setTimeout(() => {
            updateButtonCriteriaCount(modalElement);
          }, 100);
        });
      });

      modalElement.addEventListener("click", (e) => {
        if (e.target === modalElement) {
          setTimeout(() => {
            updateButtonCriteriaCount(modalElement);
          }, 100);
        }
      });
  }

  setupMobileFilterButtons();

  return {
    setupMobileFilterButtons,
    closeModal,
  };
}

window.initRechercheMobile = initRechercheMobile();
export default window.initRechercheMobile;

